module.exports = __webpack_public_path__ + "static/media/rhubarb.dba7404f.jpg";